import { render, staticRenderFns } from "./SetsignPwd.vue?vue&type=template&id=66d5a842"
import script from "./SetsignPwd.vue?vue&type=script&lang=js"
export * from "./SetsignPwd.vue?vue&type=script&lang=js"
import style0 from "./SetsignPwd.vue?vue&type=style&index=0&id=66d5a842&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports